// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"8cf8de6a","428":"73bd35a5","444":"b34740b3","548":"4a1b2db6","597":"54c6b309","642":"00d366f8","649":"3e8d4342","737":"166c6c75","882":"332f33f3","901":"f64f5dc1"}[chunkId] + ".chunk.js";
};